<template>
  <div id="front-layout">
    <!-- admin header -->
    <LayoutHeader />

    <!-- admin sidebar-->
    <!-- <LayoutLeftMenu /> -->

    <!-- admin content-->
    <LayoutContent />

    <!-- admin footer-->
    <LayoutFooter />
  </div>
</template>


<style>
@import "./../../../assets/common/front/css/layout.css";
@import "./../../../assets/common/front/css/header.css";
@import "./../../../assets/common/front/css/content.css";
@import "./../../../assets/common/front/css/footer.css";
</style>

<script>
// @ is an alias to /src
import LayoutHeader from "./Header.vue";
import LayoutContent from "./Content.vue";
import LayoutFooter from "./Footer.vue";

export default {
  name: "FrontLayout",
  components: {
    LayoutHeader,
    LayoutContent,
    LayoutFooter
  }
};
</script>